import {inject, Injectable} from '@angular/core';
import {BadgeListItem} from '../components/list/badge-list/badge-list.types';
import {DirectusTranslation} from '@frontend/directus';
import {AttributeTransformationService} from './attribute-transformation.service';

export interface SubcriteriaBadgeOptions {
  includeAttributeType?: boolean;
  sortByScaNumber?: boolean;
  identifierPrefix?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubcriteriaBadgeService {
  private readonly attributeTransformationService = inject(AttributeTransformationService);

  createBadgeListItems<
    T extends {
      directusId: string;
      scaNumber: number;
      translations: DirectusTranslation[];
      importanceScore?: string;
    },
  >(items: T[], options: SubcriteriaBadgeOptions = {}): BadgeListItem[] {
    const {
      includeAttributeType = false,
      sortByScaNumber = true,
      identifierPrefix = 'SCA',
    } = options;

    const sortedItems = sortByScaNumber
      ? [...items].sort((a, b) => a.scaNumber - b.scaNumber)
      : items;

    return sortedItems.map((item) => ({
      key: item.directusId,
      identifier: `${identifierPrefix} ${item.scaNumber}`,
      translations: item.translations,
      originalItem:
        includeAttributeType && item.importanceScore
          ? {
              ...item,
              importanceScoresTranslationKey:
                this.attributeTransformationService.getImportanceScoreTranslationKey(
                  item.importanceScore,
                ),
            }
          : item,
    }));
  }
}
